<template>
  <section class="event-password-unavailable" role="status">
    <h1>{{ $t('eventPasswordSaleUnavailableTitle') }}</h1>
    <p>{{ $t('eventPasswordSaleUnavailableDescription') }}</p>
  </section>
</template>

<script>
export default {
  name: 'event-password-unavailable',
}
</script>

<style scoped>
.event-password-unavailable {
  max-width: 596px;
  margin: 0 auto;
  padding: 48px 16px;
  text-align: center;
}
h1 {
  margin-bottom: 24px;
  color: #333;
  font-family: Raleway, sans-serif;
  font-size: 36px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -1.08px;
}
p {
  margin: 0;
  color: #666;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  line-height: 1.5;
}
@media (max-width: 600px) {
  h1 {
    font-size: 28px;
  }
}
</style>
